import domain from './domain';
import { resetCoreUserOpenTaskListData } from './events';
import { OpenTaskListData } from 'dy-frontend-shared/lib/data/types';

// Open task list data
export const $coreUserOpenTaskListData = domain
    .createStore<OpenTaskListData | null>(null)
    .reset(resetCoreUserOpenTaskListData);
